module.exports = __webpack_public_path__ + "img/y_2024.0210bf4c.png";